import { createContext, useContext, type ReactNode } from "react";

const PageEmbedContext = createContext(false);

/** Wraps page content that is rendered as a tab of a hub page (the hub already shows the title). */
export function PageEmbedProvider({ children }: { children: ReactNode }) {
  return <PageEmbedContext.Provider value>{children}</PageEmbedContext.Provider>;
}

export function useIsEmbeddedPage(): boolean {
  return useContext(PageEmbedContext);
}
